import React from "react";
import { Link } from "react-router-dom";
import LandingLayout from "./LandingLayout";

const AboutPage = () => {
  return (
    <LandingLayout title="About | Rebel">
      <section className="about-hero">
        <div className="hero-overlay"></div>

        <div className="hero-copy hero-about">
          <div className="breadcrumbs">
            <Link to="/">Home</Link>
            <span>›</span>
            <span>About Us</span>
          </div>

          <h1>
            About <span>RebelTV</span>
          </h1>

          <p className="updated">◷ Updated At: 3 months ago</p>

          <p>
            RebelTV is a next-generation content platform built for creators
            who want more than just views—they want ownership, control, and
            real income.
          </p>

          <p>
            We’re redefining how content is shared and monetized by giving
            creators the power to choose how they earn—whether through
            subscriptions, pay-per-view, or ad-supported content. No
            gatekeeping. No hidden rules. Just a direct connection between
            creators and their audience.
          </p>

          <p>
            Born from a vision to break away from traditional platforms, RebelTV
            is designed for culture, creativity, and independence. From music
            and entertainment to exclusive behind-the-scenes content, Rebel is
            where audiences come to discover and creators come to build.
          </p>

          <p className="statement">
            This isn’t just another platform.
            <br />
            <strong>This is Rebel.</strong>
          </p>
        </div>

        <div className="hero-device">
          <img
            className="laptop"
            src="/assets/about-laptop-mockup.png"
            alt="RebelTV displayed on a laptop"
          />
        </div>
      </section>

      <section className="about-sections">
        <article className="info-card">
          <div className="icon-circle">
            <img src="/assets/icons/mission.svg" alt="" />
          </div>

          <div className="card-content">
            <h2>Our Mission</h2>
            <span className="heading-line"></span>

            <p>
              To empower creators to turn their content into real businesses
              by providing the tools, freedom, and monetization options they
              need to succeed—without limitations or dependency on traditional
              platforms.
            </p>

            <p>
              We are committed to building a space where creativity is valued,
              ownership is respected, and creators are paid fairly for the
              content they produce.
            </p>
          </div>
        </article>

        <article className="info-card">
          <div className="icon-circle">
            <img src="/assets/icons/vision.svg" alt="" />
          </div>

          <div className="card-content">
            <h2>Our Vision</h2>
            <span className="heading-line"></span>

            <p>
              To become the leading Bahamian / Caribbean platform where creators
              and culture thrive—reshaping the digital content industry by
              putting power back into the hands of the creators.
            </p>

            <p>
              We envision a future where creators don’t chase platforms—platforms
              support creators.
            </p>
          </div>
        </article>

        <article className="info-card legal-card">
          <div className="icon-circle">
            <img src="/assets/icons/legal.svg" alt="" />
          </div>

          <div className="card-content">
            <h2>Legal &amp; Ownership</h2>
            <span className="heading-line"></span>

            <p>
              REBEL is owned and operated by Chatana Media and the Rebel Media
              Network, located at Earnest &amp; Mackey Street, Nassau, The
              Bahamas.
            </p>

            <p>
              All content, programming, trademarks, logos, and intellectual
              property displayed on or distributed through the REBEL platform
              are the property of Chatana Media, the Rebel Media Network, or
              their respective content creators, and are protected under
              applicable copyright, trademark, and intellectual property laws.
            </p>

            <p>
              No portion of this content may be reproduced, distributed,
              transmitted, modified, or otherwise used without prior written
              consent, except where expressly permitted by law.
            </p>
          </div>
        </article>
      </section>

      <section className="contact-strip">
        <div className="contact-main">
          <div className="contact-icon">
            <img src="/assets/icons/email.svg" alt="" />
          </div>

          <div>
            <p>
              For customer support, rights inquiries, or general information,
              please contact:
            </p>

            <a href="mailto:support@rebeltv.me">support@rebeltv.me</a>
          </div>
        </div>

        <div className="contact-point">
          <img src="/assets/icons/globe.svg" alt="" />
          <span>Built in The Bahamas.</span>
        </div>

        <div className="contact-point">
          <img src="/assets/icons/bolt.svg" alt="" />
          <span>Powered by creators worldwide.</span>
        </div>
      </section>
    </LandingLayout>
  );
};

export default AboutPage;
